import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-invalid-feedback',
  templateUrl: './invalid-feedback.component.html',
  styleUrls: ['./invalid-feedback.component.scss']
})
export class InvalidFeedbackComponent implements OnInit {
  @Input() control: AbstractControl = null as any;

  constructor() { }

  ngOnInit(): void {
  }

  @HostBinding('style.display')
  get display() {
    return this.show ? 'block' : '';
  }

  get show() {
    return this.control && this.control.invalid && (this.control.dirty || this.control.touched);
  }

  get message() {
    const key = Object.keys(this.errors)[0];
    return `errors.${key}`;
  }

  get params() {
    const key = Object.keys(this.errors)[0];
    return {
      [key]: this.errors[key],
      value: this.control.value
    };
  }

  private get errors() {
    return this.control.errors as any;
  }
}
